import { atom } from "recoil";

export const careplanStatusRecoil = atom({
  key: "careplanStatusRecoil",
  default: null,
});

export const searchKeywordAtom = atom({
  key: "searchKeywordAtom",
  default: "",
});

export const defaultFiltersAtom = atom({
  key: "defaultFiltersAtom",
  default: false,
});
